var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFileuseTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.0379,
    height: 20,
    rx: 2,
    fill: "#9B51E0",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5701 8.95631L16.0379 8.43556L14.9964 7.5L14.5286 8.02075L12.4536 10.3307L11.4696 9.4033L10.9602 8.9232L10 9.94204L10.5094 10.4221L11.5178 11.3725L11.5071 11.3844L12.0059 11.8325L12.0158 11.8418L12.5252 12.3219L12.5369 12.3095L12.5486 12.32L12.9856 11.8335L13.4854 11.3031L13.4728 11.2911L15.5701 8.95631Z",
    fill: "#9B51E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5V5.5H8.5V8.5V9H8H5V14.5H12V13.5H13V14.5V15.5H12H5H4V14.5V7.5L7 4.5H8.5H12H13V5.5V7.5H12ZM7.41421 5.5H7.5V8H5V7.91421L7.41421 5.5Z",
    fill: "#9B51E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5381 11.7929L20.2452 9.5H24.831L22.5381 11.7929Z",
    fill: "#9B51E0",
    stroke: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileuseTrue);
export default __webpack_public_path__ + "static/media/ico-fileuse-true.5775b56dcd3c128f2a2feb7ac38f3bc8.svg";
export { ForwardRef as ReactComponent };